import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ListBullet"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25 9C6.49264 9 7.5 7.99264 7.5 6.75C7.5 5.50736 6.49264 4.5 5.25 4.5C4.00736 4.5 3 5.50736 3 6.75C3 7.99264 4.00736 9 5.25 9ZM5.25 19.5C6.49264 19.5 7.5 18.4926 7.5 17.25C7.5 16.0074 6.49264 15 5.25 15C4.00736 15 3 16.0074 3 17.25C3 18.4926 4.00736 19.5 5.25 19.5ZM22.5 6H12V7.5H22.5V6ZM22.5 16.5H12V18H22.5V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ListBullet.vue"]]);
